import { HomeTitle } from ".";
import { Link } from "react-router-dom";
import TrackVisibility from "react-on-screen";

const PartnerCard = ({ isVisible, id, logo }) => {
	const animation = isVisible
		? `animate-animated animate-fadeInUp delay-${id} opacity-100`
		: "opacity-0";
	return (
		<img
			key={id}
			src={logo}
			className={`h-32 w-32 rounded-full object-contain border p-2 border-primary ${animation}`}
			alt="partenaires"
		/>
	);
};

const HomePartners = ({ langWords }) => {
	const partners = [
		{
			logo: "https://cdn.liberte-algerie.com/images/article/thumbs/d-tassili-airlines-fouille-dans-les-comptes-du-csc-9bb6b.jpg",
		},
		{
			logo: "https://cdn.liberte-algerie.com/images/article/thumbs/d-tassili-airlines-fouille-dans-les-comptes-du-csc-9bb6b.jpg",
		},
		{
			logo: "https://cdn.liberte-algerie.com/images/article/thumbs/d-tassili-airlines-fouille-dans-les-comptes-du-csc-9bb6b.jpg",
		},
		{
			logo: "https://cdn.liberte-algerie.com/images/article/thumbs/d-tassili-airlines-fouille-dans-les-comptes-du-csc-9bb6b.jpg",
		},
		{
			logo: "https://cdn.liberte-algerie.com/images/article/thumbs/d-tassili-airlines-fouille-dans-les-comptes-du-csc-9bb6b.jpg",
		},
		{
			logo: "https://cdn.liberte-algerie.com/images/article/thumbs/d-tassili-airlines-fouille-dans-les-comptes-du-csc-9bb6b.jpg",
		},
	];
	return (
		<section className="container my-28">
			<HomeTitle title={langWords.ourPartners} center />
			<div className="m-auto flex justify-center items-center flex-wrap gap-4 p-4">
				{partners.map((partner, id) => (
					<TrackVisibility key={id} partialVisibility>
						<PartnerCard id={id} logo={partner.logo} />
					</TrackVisibility>
				))}
			</div>
			<div
				className="bg-primary max-w-3xl m-auto mt-8 bg-opacity-75"
				style={{ height: ".5px" }}
			></div>
			<Link
				to="/partners"
				className="text-center py-2 capitalize px-4 mx-auto mt-4 block w-max rounded bg-primary text-secondary cursor-pointer hover:bg-opacity-90"
			>
				{langWords.beAPartner}
			</Link>
		</section>
	);
};

export default HomePartners;
